
<script>
export default {
  name: 'rex-rounded-single-select',
  props: {
    label: {
      type: String,
      default: () => null
    },
    data: {
      type: Array,
      default: () => []
    },
    selectType: {
      type: String,
      default: () => 'single'
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    arrayIndex: {
      type: Number,
      default: () => 0
    },
    isGrouped: {
      type: Boolean,
      default: () => false
    },
    hideIfEmpty: {
      type: Boolean,
      default: () => true,
    }
  },
  computed: {
    value: {
      get() {
        let value = this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)

        if (this.selectType === 'array') {
          value = value[`${this.arrayIndex}`]
        }
        return value
      },
      set(value) {
        let data = null

        if (this.selectType === 'single') {
          data = value
        } else if (this.selectType === 'array') {
          const arr = this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
          arr[`${this.arrayIndex}`] = value

          data = arr
        }

        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value: data
        })

        this.$emit('onChange', {
          event: data,
          element: this.$vnode.elm
        })
      }
    },
    selectedLabel() {
      let selected

      if (this.isGrouped) {
        const ungroupedData = [].concat(...this.data.map(item => item.collection))

        selected = ungroupedData.find(item => item.slug === this.value)
      } else {
        selected = this.data.find(item => item.slug === this.value)
      }

      return selected
        ? selected.name
        : ''
    }
  },
}
</script>

<template>
  <div
    v-if="hideIfEmpty ? data.length : true"
    :class="cssClass"
    class="rex-rounded-field rex-rounded-select"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field--label"
    >
      {{ label }}
    </h3>
    <b-dropdown
      v-model="value"
    >
      <div
        slot="trigger"
        :class="{ disabled: disabled }"
        class="rex-rounded-multiselect--header"
      >
        <p>{{ selectedLabel }}</p>
        <b-icon
          icon="chevron-down"
          custom-size="mdi-24px"
          class="rex-rounded-multiselect--custom-icon-down"
        />
      </div>
      <div
        v-for="(item, index) in data"
        :key="index"
      >
        <div v-if="isGrouped">
          <b-dropdown-item
            :value="item.slug"
            :disabled="true"
            :custom="true"
            :focusable="false"
          >
            {{ item.label }}
          </b-dropdown-item>
          <b-dropdown-item
            v-for="groupItem in item.collection"
            :key="groupItem.slug"
            :value="groupItem.slug"
            :focusable="false"
          >
            {{ groupItem.name }}
          </b-dropdown-item>
          <b-dropdown-item
            :separator="true"
          />
        </div>
        <b-dropdown-item
          v-else
          :key="item.slug"
          :value="item.slug"
          :focusable="false"
        >
          {{ item.name }}
        </b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>
